import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Policy from "./Components/Policy/Policy";
import TermsService from "./Components/TermsService/TermsService";
import "./style/reset.css";
import "./style/global.scss";
import Header from "./Components/Header/Header";
import Page404 from "./Components/Page404/Page404";

function App() {
  return (
    <main className="main-container">
      <Header />
      <Routes>
        <Route path="/service" element={<TermsService />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/" element={<Navigate replace to="/policy" />} />
        <Route path="404" element={<Page404 />} />
        <Route path="*" element={<Navigate replace to="/404" />} />
      </Routes>
    </main>
  );
}

export default App;
